import { FacetModel } from "@crescentParts/Components/Training/TrainingFiltersAccordionSection";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface OnlineManufacturerTrainingFiltersState {
    filteredTrainings: any[];
    typeFilters: FacetModel[];
    appliedFilters: any[];
    selectedFilterNamesArr: string[];
}
const initialState: OnlineManufacturerTrainingFiltersState = {
    filteredTrainings: [],
    typeFilters: [],
    appliedFilters: [],
    selectedFilterNamesArr: [], // Contains all selected filter names(used for updating filter selection)
};

const reducer = createTypedReducerWithImmer(initialState, {
    "OnlineManufacturerTraining/GenerateDynamicFilters": (
        draft: Draft<OnlineManufacturerTrainingFiltersState>,
        action: { payload: any },
    ) => {
        draft.typeFilters = action.payload.typeFilters;
    },
    "OnlineManufacturerTraining/ApplyFiltersFromUrl": (
        draft: Draft<OnlineManufacturerTrainingFiltersState>,
        action: { payload: any },
    ) => {
        draft.appliedFilters = action.payload.appliedFilters;
        draft.selectedFilterNamesArr = action.payload.selectedFilterNamesArr;
        draft.filteredTrainings = action.payload.filteredTrainings;
    },
});

(reducers as any).customOnlineManufacturerTraining = reducer;

export type CustomOnlineManufacturerTrainingState = {
    customOnlineManufacturerTraining: OnlineManufacturerTrainingFiltersState;
} & ApplicationState;

type Reducers = {
    customOnlineManufacturerTrainingReducer: typeof reducer;
};

export type CustomOnlineManufacturerTrainingActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
